export const blastValueMap = {
  none: 0,
  s: 0.05,
  m: 0.2,
  l: 1,
};
